/* Snowburd storefront helpers: order fields, apparel size breakdown + tier selection, price tables. */
(() => {
  const money = (cents) => '$' + (cents / 100).toFixed(2);
  const num = (s) => { const m = String(s).match(/(\d+)/); return m ? +m[1] : 0; };
  const fieldsFor = (formId) => document.querySelector(`[data-sb-fields][data-form="${formId}"]`);
  const variantsFor = (formId) => { const el = document.querySelector(`script[data-sb-variants="${formId}"]`); try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } };
  const optionNamesFor = (formId) => { const el = document.querySelector(`script[data-sb-options="${formId}"]`); try { return el ? JSON.parse(el.textContent) : []; } catch (e) { return []; } };

  /* Quantity tier values look like "1–11 pieces", "12–23 pieces", "48+ pieces". */
  const tierFits = (label, n) => { const m = String(label).match(/(\d+)\s*(?:[–-]\s*(\d+)|\+)/); if (!m) return false; const lo = +m[1], hi = m[2] ? +m[2] : Infinity; return n >= lo && n <= hi; };

  function selectedOptions(formId) {
    const names = optionNamesFor(formId), out = {};
    const vs = document.querySelector(`variant-selects[data-section="${formId.replace('product-form-', '')}"]`) || document.querySelector('variant-selects');
    names.forEach((name, i) => {
      if (!vs) return;
      const checked = vs.querySelector(`input[data-option-name="${CSS.escape(name)}"]:checked`);
      const sel = vs.querySelectorAll('select')[i];
      out[name] = checked ? checked.value : sel ? sel.value : '';
    });
    return out;
  }

  function findVariant(formId, opts) {
    const vars = variantsFor(formId), names = optionNamesFor(formId);
    if (!vars) return null;
    return vars.find((v) => names.every((n, i) => v.options[i] === opts[n])) || null;
  }

  function pickOption(formId, name, value) {
    const vs = document.querySelector('variant-selects'); if (!vs) return;
    const input = vs.querySelector(`input[data-option-name="${CSS.escape(name)}"][value="${CSS.escape(value)}"]`);
    if (input) { if (!input.checked) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); } return; }
    const names = optionNamesFor(formId), sel = vs.querySelectorAll('select')[names.indexOf(name)];
    if (sel && sel.value !== value) { sel.value = value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
  }

  function apparelState(f) {
    const formId = f.dataset.form, opts = selectedOptions(formId);
    const when = f.dataset.sizesWhen, wrap = f.querySelector('[data-sb-sizes-wrap]');
    const sizesOn = !!wrap && (!when || Object.values(opts).some((v) => String(v).includes(when)));
    if (wrap) wrap.hidden = !sizesOn;
    const ext = (f.dataset.ext || '').split(',').filter(Boolean);
    let total = 0, extCount = 0; const parts = [];
    if (sizesOn) f.querySelectorAll('[data-sb-size]').forEach((i) => { const n = Math.max(0, Math.round(+i.value || 0)); if (n) { total += n; parts.push(`${i.dataset.sbSize} ${n}`); if (ext.includes(i.dataset.sbSize)) extCount += n; } });
    else { const q = document.querySelector(`input[name="quantity"][form="${formId}"]`); total = q ? Math.max(1, +q.value || 1) : 1; }
    const out = f.querySelector('[data-sb-sizes-out]'); if (out) out.value = sizesOn ? parts.join(', ') : '';
    return { formId, opts, sizesOn, total, extCount, parts };
  }

  function syncApparel(f) {
    const st = apparelState(f), names = optionNamesFor(st.formId), tierName = names.find((n) => /quantity/i.test(n));
    const count = f.querySelector('[data-sb-count]');
    if (count && st.sizesOn) count.textContent = st.total ? `${st.total} piece${st.total === 1 ? '' : 's'}${st.extCount ? ` · ${st.extCount} in 2XL+ (+$${f.dataset.upcharge} each, added to your cart)` : ''}` : 'Enter how many of each size. The quantity and price tier update automatically.';
    if (tierName && st.total) {
      const vars = variantsFor(st.formId) || [], idx = names.indexOf(tierName);
      const label = [...new Set(vars.map((v) => v.options[idx]))].find((l) => tierFits(l, st.total));
      if (label && st.opts[tierName] !== label) pickOption(st.formId, tierName, label);
    }
    if (st.sizesOn) { const q = document.querySelector(`input[name="quantity"][form="${st.formId}"]`); if (q && st.total) q.value = st.total; }
    const qwrap = document.querySelector(`#Quantity-Form-${st.formId.replace('product-form-', '')}`) || document.querySelector('.product-form__quantity');
    if (qwrap) qwrap.classList.toggle('sb-hidden', st.sizesOn);
  }

  /* Called by product-form.js before the main add-to-cart request. */
  window.sbBeforeAdd = async (form, formData) => {
    const f = fieldsFor(form.getAttribute('id')); if (!f || f.dataset.apparel !== 'true') return null;
    const st = apparelState(f);
    if (st.sizesOn && !st.total) return { error: 'Enter how many pieces you need in each size.' };
    const names = optionNamesFor(st.formId), tierName = names.find((n) => /quantity/i.test(n));
    if (tierName) {
      const vars = variantsFor(st.formId) || [], idx = names.indexOf(tierName);
      const label = [...new Set(vars.map((v) => v.options[idx]))].find((l) => tierFits(l, st.total));
      const v = label && findVariant(st.formId, { ...st.opts, [tierName]: label });
      if (v) formData.set('id', v.id);
    }
    formData.set('quantity', st.total);
    const items = [], title = f.dataset.productTitle;
    const upId = +f.dataset.upchargeVariant, up = +f.dataset.upcharge || 0;
    if (st.extCount && upId && up) items.push({ id: upId, quantity: st.extCount * up, properties: { For: title, Detail: `${st.extCount} piece${st.extCount === 1 ? '' : 's'} in 2XL+ at $${up} each` } });
    const deco = Object.values(st.opts).join(' + ');
    const emb = deco.split('+').filter((p) => /embroider/i.test(p)).length;
    const reorder = f.querySelector('[data-sb-reorder]');
    const digId = +f.dataset.digitizeVariant;
    if (emb && digId && st.total < 24 && !(reorder && reorder.checked)) items.push({ id: digId, quantity: emb, properties: { For: title, Detail: `${emb} embroidered location${emb === 1 ? '' : 's'}; free at 24+ pieces` } });
    if (items.length) {
      const r = await fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      if (!r.ok) return { error: 'We couldn’t add the size upcharge or digitizing line. Please try again.' };
    }
    return null;
  };

  /* Price table: per-pack or per-piece prices for the current selection. */
  function renderTable(tbl) {
    const formId = tbl.dataset.form, vars = variantsFor(formId), names = optionNamesFor(formId);
    const qName = names.find((n) => /quantity/i.test(n)); if (!vars || !qName) { tbl.hidden = true; return; }
    const opts = selectedOptions(formId), qi = names.indexOf(qName);
    const rows = vars.filter((v) => names.every((n, i) => i === qi || v.options[i] === opts[n]));
    const apparel = tbl.dataset.apparel === 'true';
    tbl.querySelector('tbody').innerHTML = rows.map((v) => {
      const n = num(v.options[qi]) || 1, cur = v.options[qi] === opts[qName];
      return `<tr class="${cur ? 'sb-cur' : ''}"><td>${v.options[qi]}</td><td>${apparel ? money(v.price) + ' each' : money(v.price)}</td>${apparel ? '' : `<td>${n > 1 ? money(Math.round(v.price / n)) + ' each' : '—'}</td>`}</tr>`;
    }).join('');
  }

  function init() {
    document.querySelectorAll('[data-sb-fields]').forEach((f) => {
      if (f.dataset.apparel !== 'true' || f.dataset.sbInit) return; f.dataset.sbInit = '1';
      f.addEventListener('input', (e) => { if (e.target.matches('[data-sb-size]')) syncApparel(f); });
      document.addEventListener('change', (e) => { if (e.target.matches(`input[name="quantity"][form="${f.dataset.form}"]`)) syncApparel(f); });
      syncApparel(f);
    });
    document.querySelectorAll('[data-sb-price-table]').forEach(renderTable);
  }
  /* Quote links pass ?product= to the contact page; prefill the message. */
  function prefillQuote() {
    const p = new URLSearchParams(location.search).get('product'), body = document.getElementById('ContactForm-body');
    if (p && body && !body.value) body.value = `Quote request: ${p}\nSize:\nQuantity:\nMaterial / options:\nNeeded by:\n`;
  }
  document.addEventListener('DOMContentLoaded', () => { init(); prefillQuote(); });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(() => {
      document.querySelectorAll('[data-sb-price-table]').forEach(renderTable);
      document.querySelectorAll('[data-sb-fields][data-apparel="true"]').forEach(syncApparel);
    }, 50));
  }
})();
